module.exports = __webpack_public_path__ + "static/media/earnedInADay_75000_100000.38571843.png";